// extracted by mini-css-extract-plugin
module.exports = {"math":"MathBlock-module--math--29gQX"};